import woltInstance from '../../wolt/instance'

const storeWoltDriverDeliveries = (data) => {
    return woltInstance.post('/driverIntegrations/deliveries', data)
}

export default storeWoltDriverDeliveries